import React, { useEffect } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getReviews } from "../features/reviews/reviewSlice";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Product Title",
    dataIndex: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Reviewer Name",
    dataIndex: "username",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Mobile",
    dataIndex: "phone",
  },
  {
    title: "Rating",
    dataIndex: "rating",
  },
  {
    title: "Comment",
    dataIndex: "comment",
  },
];

const Reviewslist = () => {
  const dispatch = useDispatch();

  const reviewstate = useSelector((state) => state.review.reviews);
  const isLoading = useSelector((state) => state.review.isLoading);

  useEffect(() => {
    dispatch(getReviews());
  }, []);

  // const data1 = [];
  // for (let i = 0; i < reviewstate.length; i++) {
  //   if (reviewstate[i].role !== "admin") {
  //     data1.push({
  //       key: i + 1,
  //       // name: reviewstate[i].firstname + " " + reviewstate[i].lastname,
  //       name: reviewstate[i].name,
  //       username: reviewstate[i].userId.name,
  //       rating: reviewstate[i].rating,
  //       comment: reviewstate[i].comment,
  //       email: reviewstate[i].userId.email,
  //       phone: reviewstate[i].userId.phone,
  //     });
  //   }
  // }

  const data1 = reviewstate?.length
    ? reviewstate.map((review, index) => ({
        key: index + 1,
        name: review.name,
        username: review.userId?.name || "N/A", // Safely access userId.name
        rating: review.rating,
        comment: review.comment,
        email: review.userId?.email || "N/A", // Safely access userId.email
        phone: review.userId?.phone || "N/A", // Safely access userId.phone
      }))
    : [];

  return (
    <div>
      <h3 className="mb-4 title">Reviews</h3>
      {/* <div>
        <Table columns={columns} dataSource={data1} />
      </div> */}
            {isLoading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <Table columns={columns} dataSource={data1} />
        </div>
      )}
    </div>
  );
};

export default Reviewslist;
